import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'material-ui/Tabs';
import { tabStyles } from '../../../theme/AllocateBaseTheme';

import PatientNotes from './PatientNotes';
import PatientVisitInfo from './PatientHistoricVisits';
import PatientEdit from './../../../containers/Patients/Edit/PatientEditContainer';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('patients');

function PatientDetailsTabs(props) {
  const { patient, canEditPatients, updatePatientIsActiveStatus } = props;
  const id = patient.id;
  return (
    <React.Fragment>
      <div className="row TabTitle" style={{ display: 'none' }}>
        <h5 type="title">{locale.getMsg('patientDetails')}</h5>
      </div>
      <Tabs
        className="custom-main-tabs"
        tabItemContainerStyle={tabStyles.tabItemContainerStyle}
        inkBarStyle={tabStyles.inkBarStyle}
      >
        <Tab buttonStyle={tabStyles.buttonStyle} label={locale.getMsg('details')}>
          <PatientEdit
            patient={patient}
            canEditPatients={canEditPatients}
            updatePatientIsActiveStatus={updatePatientIsActiveStatus}
          />
        </Tab>
        <Tab buttonStyle={tabStyles.buttonStyle} label={locale.getMsg('visitRecord')}>
          <PatientVisitInfo patientId={id} />
        </Tab>
        <Tab buttonStyle={tabStyles.buttonStyle} label={locale.getMsg('patientNotes')}>
          <PatientNotes canEditPatients={canEditPatients} />
        </Tab>
      </Tabs>
    </React.Fragment>
  );
}

PatientDetailsTabs.propTypes = {
  patient: PropTypes.shape({
    address: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      postCode: PropTypes.string,
    }),
    patientFullName: PropTypes.string,
  }).isRequired,
  canEditPatients: PropTypes.bool.isRequired,
};

export default PatientDetailsTabs;
